import React from 'react';
import DeckBuildActivity from './DeckBuildActivity';

const keyFor = id => `dk.build-duration.${id}`;
export function expectedBuildTime(id) {
  try {
    const raw = id == null ? null : localStorage.getItem(keyFor(id));
    const ms = Number(raw);
    return raw !== null && Number.isFinite(ms) && ms > 0 ? Math.min(45000, Math.max(8000, ms)) : 30000;
  } catch (_) { return 30000; } // Optional calibration; storage can be unavailable.
}
export function recordBuildTime(id, ms) {
  if (id == null || !Number.isFinite(ms) || ms <= 0) return;
  try { localStorage.setItem(keyFor(id), String(ms)); }
  catch (_) { /* The completed build is usable even without local storage. */ }
}
export function buildPercent(elapsed, expected) {
  const ratio = Math.max(0, elapsed) / expected;
  return ratio <= 1 ? 2 + 93 * (1 - Math.exp(-3 * ratio)) / (1 - Math.exp(-3))
    : 95 + 4.9 * (1 - 1 / ratio);
}

export default function BuildProgress({ build }) {
  if (!build) return null;
  return <div className="dk-build-progress" data-testid="build-progress">
    <DeckBuildActivity compact startedAt={build.started} />
  </div>;
}
